import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import MatchRatingComponent from './MatchRatingComponent';
import BolillaWidget from '../bolilla/BolillaWidget';
export default class MatchInjectedContent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.match = null;
    this.loading = true;
    this.loadMatch();
  }
  loadMatch() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches-by-discussion/".concat(this.discussion.id()),
      params: {
        include: 'players,votes,votes.user,votes.player,bolillaVotes,bolillaVotes.user'
      }
    }).then(response => {
      if (response && response.data) {
        this.match = app.store.pushPayload(response);
      }
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading || !this.match) return m("div", null);
    const isRatingPost = parseInt(this.match.discussionId()) === parseInt(this.discussion.id()) || parseInt(this.match.preMatchDiscussionId()) === parseInt(this.discussion.id());
    const isBolillaPost = parseInt(this.match.bolillaDiscussionId()) === parseInt(this.discussion.id());
    return m("div", {
      className: "MatchInjectedContent"
    }, isBolillaPost && m(BolillaWidget, {
      match: this.match
    }), isRatingPost && m(MatchRatingComponent, {
      match: this.match,
      discussion: this.discussion
    }), m("div", {
      className: "MatchInjectedContent-FooterLinks"
    }, isBolillaPost && m(Link, {
      href: "/la-bolilla/".concat(this.match.seasonName().replace('/', '-')),
      className: "Button Button--link"
    }, m("i", {
      className: "fas fa-list-ol"
    }), " Ver clasificaci\xF3n de La Bolilla"), isRatingPost && m(Link, {
      href: "/clasificacion-11-aldeanos/".concat(this.match.seasonName().replace('/', '-')),
      className: "Button Button--link"
    }, m("i", {
      className: "fas fa-trophy"
    }), " Ver clasificaci\xF3n 11 Aldeanos")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/MatchInjectedContent', MatchInjectedContent);